import { Component, Input, TemplateRef } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgbOffcanvas, NgbOffcanvasModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { IconsModule } from 'src/app/core/icons/icons.module';
import { QuoteSteps } from 'src/app/shared/constants/quote-steps.constant';
import { AbstractPageForm } from 'src/app/shared/page-classes/page-form.abstract';
import { NavbarNavComponent } from './navbar-nav/navbar-nav.component';

@Component({
	selector: 'pkd-navbar',
	imports: [RouterModule, NavbarNavComponent, NgbOffcanvasModule, IconsModule],
	templateUrl: './navbar.component.html',
	styleUrl: './navbar.component.scss',
})
export class NavbarComponent extends AbstractPageForm {
	@Input() useAltHeader = false;
	@Input() removeNav = false;

	public navbarClasses: string[] = [];

	constructor(
		private authService: AuthService,
		private offcanvasService: NgbOffcanvas,
	) {
		super();
	}

	public async openCanvas(content: TemplateRef<any>): Promise<void> {
		this.offcanvasService.open(content, { ariaLabelledBy: 'offcanvasNavbarLabel', position: 'end' });
	}

	get isLoggedIn() {
		return !!this.authService.authFields?.loggedInUser && window.location.pathname.split('/').filter(Boolean)[0] === 'portal';
	}

	get navbarClass() {
		return this.navbarClasses.join(' ');
	}

	get agentName() {
		return this.promoCode.agent.name;
	}

	get logo() {
		const type =
			this.promoCode.agent.eCommerceWebsite?.navbarLogoAttachment.contentType +
			'/' +
			this.promoCode.agent.eCommerceWebsite?.navbarLogoAttachment.contentSubType;
		return 'data:' + type + ';base64, ' + this.promoCode.agent.eCommerceWebsite?.navbarLogoAttachmentBase64.response;
	}

	public goSmartBegin() {
		window.location.href = '/';
		this.appStateService.goToStep(QuoteSteps.SMART_BEGIN);
		this.offcanvasService.dismiss('Navigated');
	}
}
